'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = resetCookies;

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resetCookies() {
  _reactCookie2.default.remove('orderNumber', { path: '/' });
  _reactCookie2.default.remove('orderToken', { path: '/' });
  _reactCookie2.default.remove('hasOrder', { path: '/' });

  if (location && location.hostname && location.hostname.indexOf('.') !== -1) {
    var domain = location.hostname.substring(location.hostname.indexOf('.'));
    _reactCookie2.default.remove('orderNumber', { path: '/', domain: domain });
    _reactCookie2.default.remove('orderToken', { path: '/', domain: domain });
    _reactCookie2.default.remove('hasOrder', { path: '/', domain: domain });
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/resetCookies.js
// module id = 558
// module chunks = 0